import React from 'react';
import { Container, Typography, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import './OurApps.scss';

import liftlogScreen from '../../pages/LifeLog/images/home.png';
import relayrScreen from '../../pages/Relayr/images/networks.png';

const apps = [
    {
        name: 'LiftLog',
        tagline: 'Your Gym Journal, Reimagined',
        description: 'Track workouts, monitor progress, and hit new personal records. Built for lifters who want results.',
        link: '/liftlog',
        accentColor: '#D4A843',
        status: 'Available',
        screenshot: liftlogScreen,
        screenshotAlt: 'LiftLog app home screen',
    },
    {
        name: 'Relayr',
        nameHighlight: 'R',
        tagline: 'Your Communities, Connected',
        description: 'Join networks, discover communities, and chat in real-time. A modern platform for meaningful conversations.',
        link: '/relayr',
        accentColor: '#6C5CE7',
        status: 'Coming Soon',
        screenshot: relayrScreen,
        screenshotAlt: 'Relayr app networks screen',
    },
];

const OurApps = () => (
    <section className="our-apps-section" id="apps">
        <Container maxWidth="lg">
            <Typography variant="overline" className="our-apps-label">
                Our Products
            </Typography>
            <Typography variant="h5" className="our-apps-title">
                Apps We've Built
            </Typography>
            <Typography className="our-apps-sub">
                Products designed with purpose — clean, modern, and built to solve real problems.
            </Typography>

            <Grid container spacing={3} className="our-apps-grid">
                {apps.map((app, i) => (
                    <Grid item xs={12} sm={6} key={i}>
                        <Link to={app.link} className="app-card-link">
                            <div
                                className="app-card"
                                style={{ '--app-accent': app.accentColor }}
                            >
                                <div className="app-card-content">
                                    <div className="app-card-info">
                                        <div className="app-card-header">
                                            <Typography variant="h5" className="app-name">
                                                {app.nameHighlight ? (
                                                    <>
                                                        {app.name.slice(0, app.name.lastIndexOf(app.nameHighlight))}
                                                        <span className="app-name-highlight">{app.nameHighlight}</span>
                                                    </>
                                                ) : (
                                                    app.name
                                                )}
                                            </Typography>
                                            <span className="app-status">{app.status}</span>
                                        </div>
                                        <Typography className="app-tagline">
                                            {app.tagline}
                                        </Typography>
                                        <Typography className="app-description">
                                            {app.description}
                                        </Typography>
                                        <span className="app-cta">
                                            Learn more &rarr;
                                        </span>
                                    </div>
                                    <div className="app-card-screenshot">
                                        <img src={app.screenshot} alt={app.screenshotAlt} loading="lazy" />
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </Grid>
                ))}
            </Grid>
        </Container>
    </section>
);

export default OurApps;
